module.exports = __webpack_public_path__ + "static/img/moren_bg.190fed23.jpg";